/**
 * The themes supported by this component.
 * @type {Object<String>}
 */
export const THEMES = {
    TWELVE: 12,
    FIFTEEN: 15
};

/**
 * The sizes supported by this component.
 * @type {Object}
 */
export const SIZES = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl'
};

/**
 * Used by the "center" props.
 * @type {String}
 */
export const CENTER = 'center';

/**
 * The error thrown when no <Col> component is provided.
 * @type {String}
 */
export const MINIMUM_COL_AMOUNT_ERROR = 'Please provide at lease one <Col> component.';

/**
 * The error thrown when trying to use children other than <Col>.
 * @type {String}
 */
export const GRID_CHILD_ERROR = 'Only <Col> components are valid children of <Grid>.';
